import React from "react";

export default function Funding(){
    return(
        <div className="max-w-[85rem] px-4 py-10 sm:px-6 lg:px-8 lg:py-14 mx-auto">
            <div className="grid grid-cols-1 gap-x-12 gap-y-16 sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-3">
                <div className="text-center">
                    <img className="w-auto h-32 mx-auto text-gray-800 opacity-50 rounded-lg"
                         src="https://dummyimage.com/300x200" alt="description"/>
                    <div className="mt-2 sm:mt-6">
                        <p className="text-xl font-bold text-orange-500">
                            Name No.1
                        </p>
                        <p className="text-lg mt-2 sm:mt-4 text-gray-500">
                            " This is a description of company / product No.1 This is a description of company / product No.1 "
                        </p>
                    </div>
                </div>
                <div className="text-center">
                    <img className="w-auto h-32 mx-auto text-gray-800 opacity-50 rounded-lg"
                         src="https://dummyimage.com/300x200" alt="description"/>
                    <div className="mt-2 sm:mt-6">
                        <p className="text-xl font-bold text-orange-500">
                            Name No.2
                        </p>
                        <p className="text-lg mt-2 sm:mt-4 text-gray-500">
                            " This is a description of company / product No.2 This is a description of company / product No.2 "
                        </p>
                    </div>
                </div>
                <div className="text-center">
                    <img className="w-auto h-32 mx-auto text-gray-800 opacity-50 rounded-lg"
                         src="https://dummyimage.com/300x200" alt="description"/>
                    <div className="mt-2 sm:mt-6">
                        <p className="text-xl font-bold text-orange-500">
                            Name No.3
                        </p>
                        <p className="text-lg mt-2 sm:mt-4 text-gray-500">
                            " This is a description of company / product No.3 This is a description of company / product No.3 "
                        </p>
                    </div>
                </div>
                <div className="text-center">
                    <img className="w-auto h-32 mx-auto text-gray-800 opacity-50 rounded-lg"
                         src="https://dummyimage.com/300x200" alt="description"/>
                    <div className="mt-2 sm:mt-6">
                        <p className="text-xl font-bold text-orange-500">
                            Name No.4
                        </p>
                        <p className="text-lg mt-2 sm:mt-4 text-gray-500">
                            " This is a description of company / product No.4 This is a description of company / product No.4 "
                        </p>
                    </div>
                </div>
                <div className="text-center">
                    <img className="w-auto h-32 mx-auto text-gray-800 opacity-50 rounded-lg"
                         src="https://dummyimage.com/300x200" alt="description"/>
                    <div className="mt-2 sm:mt-6">
                        <p className="text-xl font-bold text-orange-500">
                            Name No.5
                        </p>
                        <p className="text-lg mt-2 sm:mt-4 text-gray-500">
                            " This is a description of company / product No.5 This is a description of company / product No.5 "
                        </p>
                    </div>
                </div>
                <div className="text-center">
                    <img className="w-auto h-32 mx-auto text-gray-800 opacity-50 rounded-lg"
                         src="https://dummyimage.com/300x200" alt="description"/>
                    <div className="mt-2 sm:mt-6">
                        <p className="text-xl font-bold text-orange-500">
                            Name No.6
                        </p>
                        <p className="text-lg mt-2 sm:mt-4 text-gray-500">
                            " This is a description of company / product No.6 This is a description of company / product No.6 "
                        </p>
                    </div>
                </div>
                <div className="text-center">
                    <img className="w-auto h-32 mx-auto text-gray-800 opacity-50 rounded-lg"
                         src="https://dummyimage.com/300x200" alt="description"/>
                    <div className="mt-2 sm:mt-6">
                        <p className="text-xl font-bold text-orange-500">
                            Name No.7
                        </p>
                        <p className="text-lg mt-2 sm:mt-4 text-gray-500">
                            " This is a description of company / product No.7 This is a description of company / product No.7 "
                        </p>
                    </div>
                </div>
                <div className="text-center">
                    <img className="w-auto h-32 mx-auto text-gray-800 opacity-50 rounded-lg"
                         src="https://dummyimage.com/300x200" alt="description"/>
                    <div className="mt-2 sm:mt-6">
                        <p className="text-xl font-bold text-orange-500">
                            Name No.8
                        </p>
                        <p className="text-lg mt-2 sm:mt-4 text-gray-500">
                            " This is a description of company / product No.8 This is a description of company / product No.8 "
                        </p>
                    </div>
                </div>
                <div className="text-center">
                    <img className="w-auto h-32 mx-auto text-gray-800 opacity-50 rounded-lg"
                         src="https://dummyimage.com/300x200" alt="description"/>
                    <div className="mt-2 sm:mt-6">
                        <p className="text-xl font-bold text-orange-500">
                            Name No.9
                        </p>
                        <p className="text-lg mt-2 sm:mt-4 text-gray-500">
                            " This is a description of company / product No.9 This is a description of company / product No.9 "
                        </p>
                    </div>
                </div>
            </div>
        </div>
    )
}